import React from 'react'
import { IonContent, IonPage } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import HeaderNav from '../../../components/headerNav/HeaderNav.component'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import PatientSearchContent from '../pageContent/PatientSearch.content'
import { useDispatch, useSelector } from 'react-redux'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'
import { useOfflineStatus } from '../../../utilities/isOnline.util'
import { getPatientInformationState } from '../../patientInformation/selectors/patientInformation.selector'
import { newPtClick } from '../../../utilities/patientSearch.util'
import { IPatientSearchState } from '../store/patientSearch.types'
import { getPatientSearchState } from '../selectors'

const PatientSearch: React.FC = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const dispatch = useDispatch()
  const isOfflineStatus = useOfflineStatus()
  const { hidePatientAndBilling } = useSelector(getPatientInformationState)
  const patientSearchState: IPatientSearchState = useSelector(getPatientSearchState)
  const { showImportDataConfirmationAlert } = patientSearchState
  const onBackClick = () => {
    history.push(TabConstants.PATIENT_INFO_ROUTE)
  }

  const onNewPtClick = () => {
    newPtClick(dispatch, showImportDataConfirmationAlert, t, patientSearchState, history)
  }

  return (
    <IonPage id='PatientSearchPage'>
      <PCRHeader />
      <HeaderNav
        prevOnClick={onBackClick}
        prevLabel={t('common.buttons.Back')}
        title={t('patientSearch.patientSearch')}
        isBackButton={true}
        nextLabel={isOfflineStatus && hidePatientAndBilling ? t('patientSearch.newPatient') : undefined}
        nextOnClick={onNewPtClick}
      />
      <IonContent color='light'>
        <PatientSearchContent />
      </IonContent>
    </IonPage>
  )
}

export default PatientSearch
